<template>
  <div :class="['layout-view', offset]">
    <controls-panel v-if="this.$route.params.farm_id && this.$route.params.farm_id !== '-1'"></controls-panel>
    <farm-panel @farm-selected="onFarmSelected"></farm-panel>
    <mixers-table></mixers-table>
  </div>
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import FarmPanel from './common/FarmPanel'
import ControlsPanel from './ControlsPanel'
import MixersTable from './table/MixersTable'

export default {
  name: 'Mixers',

  mixins: [adaptationMixin],
  data: () => ({
    show: false
  }),
  components: {
    ControlsPanel,
    MixersTable,
    FarmPanel
  },
  computed: {
    offset () {
      return {
        'layout-view--offset-top': !this.$route.params.farm_id
      }
    }
  },
  methods: {
    onFarmSelected (farmId, companyId) {
      const clientId = this.$route.params.client_id || this.$store.getters.clientId
      const route = farmId !== '-1'
        ? `/app/clients/${clientId}/admin/mixers/companies/${companyId}/farms/${farmId}`
        : `/app/clients/${clientId}/admin/mixers`

      this.$router.push(route)
    }
  }
}
</script>
